<template>
  <div class="card">
    <div class="sac__font-18 n60 center">
      This Virtual Visit has <br>been provided to you by:
    </div>
    <div class="margin-top-16 flex-row just-center">
      <div
        v-if="customerPartnerSettings?.LOGO_URL"
        class="p-logo-container"
        :style="{ backgroundColor: partnerColor }"
      >
        <img
          :src="logo"
          alt="logo"
          class="logo-img"
        />
      </div>
      <img
        v-else
        :src="logo"
        alt="logo"
        class="logo-img"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import smartACLogo from '@shared/assets/img/logo/black-logo.png';

export default {
  name: 'PartnerLogo',
  computed: {
    ...mapState({
      customerPartnerSettings: (state) => state.customerDetail.customerPartnerSettings,
      partnerSettings: (state) => state.admin.partnerSettings,
    }),
    partnerColor() {
      return this.customerPartnerSettings?.PRIMARY_COLOR;
    },
    logo() {
      const {
        LOGO_URL: logoUrl,
      } = this.customerPartnerSettings;
      const {
        LOGO_URL: pLogoUrl,
      } = this.partnerSettings;
      if (logoUrl) {
        return logoUrl;
      }
      if (pLogoUrl) {
        return pLogoUrl;
      }
      return smartACLogo;
    },
  },
};
</script>
<style scoped lang="scss">
.card {
  padding: 2rem;
  display: grid;
  justify-content: center;
  align-items: center;
  .logo-img {
    height: auto;
    width: 150px;
  }
  .p-logo-container {
    height: 140px;
    width: 140px;
    border-radius: 6px;
    padding: 4px;
    .logo-img {
      height: 100%;
      width: 100%;
      object-fit: contain;
    }
  }
}
</style>
